import React from "react";
import { Modal, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Congregation, Speaker } from "../../../../../types/scheduling/weekend";
import { CongName } from "../../../common";
import { nameOfUser } from "../../../../../helpers/user";

interface SpeakerInfoModalProps {
  speaker: Speaker;
  speakerCong?: Congregation;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const SpeakerInfoModal: React.FC<SpeakerInfoModalProps> = (props) => {
  const { t } = useTranslation();
  const handleClose = () => props.setShow(false);

  return (
    <Modal show={props.show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("schedules.weekend.speaker-info")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped hover>
          <tbody>
            <tr key="speaker_name">
              <td>{t("general.name")}</td>
              <td>{nameOfUser(props.speaker)}</td>
            </tr>
            {!!props.speaker?.cellphone && (
              <tr>
                <td>{t("userinfo.cellphone")}</td>
                <td>{props.speaker.cellphone}</td>
              </tr>
            )}
            {!!props.speaker?.homephone && (
              <tr>
                <td>{t("userinfo.homephone")}</td>
                <td>{props.speaker.homephone}</td>
              </tr>
            )}
            {!!props.speaker?.otherphone && (
              <tr>
                <td>{t("userinfo.otherphone")}</td>
                <td>{props.speaker?.otherphone}</td>
              </tr>
            )}
            {!!props.speaker?.email && (
              <tr key="email">
                <td>{t("userinfo.email")}</td>
                <td>
                  <a href={`mailto:${props.speaker?.email}`}>{props.speaker?.email}</a>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <hr />
        <b>{CongName(props.speakerCong)}</b>
        {!!props.speakerCong?.ptc_info && (
          <div className="mt-2">
            <div className="bold">{t("schedules.settings.ptc-contact")}</div>
            <div className="pre-regular">{props.speakerCong.ptc_info}</div>
          </div>
        )}
        {!!props.speakerCong?.notes && <div className="mt-2 pre-regular">{props.speakerCong.notes}</div>}
      </Modal.Body>
    </Modal>
  );
};
